import { Box, Group } from '@mantine/core';

import { Production } from '../../data-access/types/stats';
import ProductionChart from '../production-chart/production-chart';

import classes from './production-synthesis.module.css';

interface ProductionSynthesisProps {
  crop: string;
  data: Production;
}

export function ProductionSynthesis({ crop, data }: ProductionSynthesisProps) {
  return (
    <Box className={classes.container} miw={600}>
      <Group align="center" className={classes.titleContainer}></Group>

      <ProductionChart data={data} />

      <Group justify="space-around" mt="md"></Group>
    </Box>
  );
}

export default ProductionSynthesis;
